import { useEffect, useRef, useState } from 'react';
import { api } from '../../../api.js';

/**
 * DeleteConfirmPopover — anchored confirmation popover for bulk-delete.
 *
 * Extracted from BulkActionBar's inline confirm. Same backend call;
 * UI is anchored popover instead of inline bar expansion.
 */
export default function DeleteConfirmPopover({ caseId, ids, count, anchorRef, placement = 'left', onClose, onCompleted }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current?.contains(e.target)) return;
      if (anchorRef?.current?.contains(e.target)) return;
      onClose?.();
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [anchorRef, onClose]);

  async function handleDelete() {
    setBusy(true);
    setError(null);
    try {
      await api.post(`/documents/case/${caseId}/bulk-delete`, { document_ids: ids });
      onCompleted?.(`Deleted ${count} file${count === 1 ? '' : 's'}`);
    } catch (err) {
      setError(err.message || 'Delete failed');
      setBusy(false);
    }
  }

  return (
    <div
      ref={ref}
      className={`bulk-popover bulk-popover--danger ${placement === 'right' ? 'bulk-popover--right' : ''}`}
      role="dialog"
      aria-label="Confirm delete"
    >
      <div className="bulk-popover-title">
        ⚠️ Permanently delete {count} file{count === 1 ? '' : 's'}?
      </div>
      <div className="bulk-popover-body">
        This cannot be undone.
      </div>
      {error && <div className="bulk-popover-error">{error}</div>}
      <div className="bulk-popover-actions">
        <button type="button" className="btn btn-sm" onClick={onClose} disabled={busy}>Cancel</button>
        <button type="button" className="btn btn-sm btn-danger" onClick={handleDelete} disabled={busy}>
          {busy ? 'Deleting…' : 'Yes, delete'}
        </button>
      </div>
    </div>
  );
}
